
import React from "react";
import TaskRow from "../TaskRow";

import {
    TaskList as List,
    Message
} from "../design";

const TaskList = ({
                      tasks,
                      loading,
                      error,
                      busy,
                      onPreview,
                      onStatusChange,
                      onDelete,
                      onOpen
                  }) => {
    if (loading) {
        return <Message>Aufgaben werden geladen...</Message>;
    }

    if (error) {
        return <Message>Fehler: {error}</Message>;
    }

    if (tasks.length === 0) {
        return <Message>Keine Aufgaben vorhanden.</Message>;
    }

    return (
        <List>
            {tasks.map(task => (
                <TaskRow
                    key={task.id}
                    task={task}
                    busy={busy}
                    onPreview={onPreview}
                    onStatusChange={onStatusChange}
                    onDelete={onDelete}
                    onOpen={onOpen}
                />
            ))}
        </List>
    );
};

export default TaskList;
